
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ReactNode } from "react";

type Props = {
    visible: boolean;
    onHide: () => void;
    mensagem: string|ReactNode;
    titulo: string;
}

export default function MensagemAlertaDialog({ visible, onHide, mensagem, titulo }: Props) {

    return (
        <Dialog
            header={<div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <FontAwesomeIcon icon={"triangle-exclamation"} color={"#EBC106"} />
                {titulo}
            </div>}
            visible={visible}
            style={{ width: "450px" }}
            onHide={() => onHide()}
            footer={
                <div>
                    <Button
                        label="OK"
                        onClick={() => onHide()}
                    />
                </div>
            }
        >
            <span>{mensagem}</span>
        </Dialog>
    )
}